import {
  Dialog,
  DialogActions,
  DialogContentText,
  Theme,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { makeStyles } from '@mui/styles';
import { memo, ReactElement } from 'react';
import { PmiDialogContent } from 'shell/components/shared/dialog/content';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';

//Set the styles
const useStyles = makeStyles((theme: Theme) => ({
  paper: ({ fullScreen }: { fullScreen: boolean }) => ({
    minWidth: fullScreen ? undefined : '30rem',
    color: theme.palette.cdmBrand.main,
  }),
}));
interface ElectoralModal {
  open: boolean;
  onClose: () => void;
  message: string;
  title: string;
}
const ElectoralErrorHandlerComponent = ({
  open,
  onClose,
  message,
  title,
}: ElectoralModal): ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));
  const classes = useStyles({ fullScreen });

  return (
    <>
      <Dialog
        open={!!open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        classes={{ paper: classes.paper }}
        fullScreen={fullScreen}
      >
        <PmiDialogTitle id="alert-dialog-title" color="white" backgroundColor="cdmBrand">
          {title}
        </PmiDialogTitle>
        <PmiDialogContent>
          <DialogContentText key={message} id="alert-dialog-description">
            {message}
          </DialogContentText>
        </PmiDialogContent>
        <DialogActions>
          <PmiButton onClick={onClose} variant="outlined" color="cdmBrand">
            Ho capito
          </PmiButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

ElectoralErrorHandlerComponent.displayName = 'Electoral Error handler - modal component';

export const ElectoralErrorHandler = memo(ElectoralErrorHandlerComponent);
